let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8B3qQ")).then(() => parcelRequire('ffQS3'));